import { Stack } from '@mui/material';

import { SourceCohortsCard } from './SourceCohortsCard';
import { TablesSection } from './TablesSection';
import { TablesStaleBanner } from '../../components/TablesStaleBanner';
import { useAnalysisDefinitionTab } from '../../hooks/useAnalysisDefinitionTab';

// Analytical dataset land in follow-up work.
export const AnalysisDefinitionTab = () => {
  const { isLoading, resultsStaleness } = useAnalysisDefinitionTab();

  return (
    // Takes exactly the page body's height (not its content's: a dataset grid's content
    // is every row), which the tables card passes on to the grid so the grid scrolls
    // inside it with its footer in view. The sections keep their own minimum heights, so
    // when the body is too short the page scrolls instead of squeezing them.
    <Stack spacing={6} sx={{ flex: 1, minHeight: 0 }} data-testid="analysis-definition-tab">
      {resultsStaleness && <TablesStaleBanner staleness={resultsStaleness} />}
      <SourceCohortsCard isLoading={isLoading} />
      <TablesSection isLoading={isLoading} />
    </Stack>
  );
};
